import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';

/**
 * The route table. W1-A's `/mock/` pages are for Scott's review (R-WEB-3, R-WEB-7), synthetic data only, each loaded on
 * its own so none of it reaches the main bundle; W1-B replaces them with the screens.
 */
const ResultsMock = lazy(() => import('./mock/ResultsMock'));
const ProfileMock = lazy(() => import('./mock/ProfileMock'));
const TechServicesMock = lazy(() => import('./mock/TechServicesMock'));

export function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/mock/results" element={<ResultsMock />} />
        <Route path="/mock/profile" element={<ProfileMock />} />
        <Route path="/mock/tech-services" element={<TechServicesMock />} />
        <Route path="*" element={<Placeholder />} />
      </Routes>
    </Suspense>
  );
}

/** Until the screens exist: the header logo and nothing else. */
function Placeholder() {
  return (
    <main className="placeholder">
      <img src="/brand/RVTC-FullHeaderLogo-Light_Claude-proposed_v0.2.svg" alt="RVTechConnect. The Right Tech. The Right Place. The Right Time." height={34} />
    </main>
  );
}
